/**
 * Menu Button component terms
 *
 * @package ext-components-base
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export const menuButton = {
	component: {
		label: "component:menuButton#label",
		description: "component:menuButton#description"
	}
};
